import { render, staticRenderFns } from "./overview-main-card-competence-select.component.vue?vue&type=template&id=6ef4c5e3&scoped=true&"
import script from "./overview-main-card-competence-select.component.vue?vue&type=script&lang=ts&"
export * from "./overview-main-card-competence-select.component.vue?vue&type=script&lang=ts&"
import style0 from "./overview-main-card-competence-select.component.vue?vue&type=style&index=0&id=6ef4c5e3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef4c5e3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VDatePicker,VMenu,VRow,VTextField})
